import { render, staticRenderFns } from "./KioskSub.vue?vue&type=template&id=6c08c8ee&scoped=true&"
import script from "./KioskSub.vue?vue&type=script&lang=js&"
export * from "./KioskSub.vue?vue&type=script&lang=js&"
import style0 from "./KioskSub.vue?vue&type=style&index=0&id=6c08c8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08c8ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VBtnToggle,VRow,VSpacer,VToolbar})
